import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchPropertyCommonAreasForFilterDone = (state,{ payload }) => {
    state.fetchedPropertyCommonAreas=payload;
}
const selectPropertyCommonAreasForFilterDone = (state,{ payload }) => {
    state.selectedPropertyCommonAreas=payload;
 }

const clearPropertyCommonAreasForFilterDone = () => {
    return initialState;
  };

  const clearSelectedPropertyCommonAreas = (state, { payload })  => {
    return {...state, selectedPropertyCommonAreas:[] };
  }; 

  const initialState = {
    fetchedPropertyCommonAreas: [],
    selectedPropertyCommonAreas:[]
  };
export default createReducer(initialState, {
  [TYPES.FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE]:fetchPropertyCommonAreasForFilterDone,
  [TYPES.SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE]:selectPropertyCommonAreasForFilterDone,
  [TYPES.CLEAR_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE]:clearPropertyCommonAreasForFilterDone,
  [TYPES.CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE]:clearSelectedPropertyCommonAreas

});